import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainLayout from '../../components/Layout/MainLayout';
import { Bell, Mail, Smartphone, MessageSquare, Moon, Sun } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { useTheme } from '../../contexts/ThemeContext';
const Notifications: React.FC = () => {
  const { t } = useTranslation();
  const {
    theme,
    toggleTheme
  } = useTheme();
  const [notifications, setNotifications] = useState({
    billReminders: true,
    paymentConfirmations: true,
    consumptionAlerts: false,
    energySavingTips: true,
    systemUpdates: true,
    emailNotifications: true,
    pushNotifications: false,
    smsNotifications: false
  });
  const updateNotification = (key: keyof typeof notifications) => {
    setNotifications(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Only show energy saving tips when the setting is enabled
  const shouldShowTips = notifications.energySavingTips;
  return <MainLayout title={t('settings.notifications')} showBackButton>
      <div className="p-4 space-y-6">
        {/* Notification Types */}


        {/* Notification Channels */}
        <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">{t('settings.notificationChannels')}</h3>
          
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              
              
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <Bell className="w-5 h-5 text-green-500" />
                <span className="font-medium text-gray-900 dark:text-white">{t('settings.pushNotifications')}</span>
              </div>
              <Switch checked={notifications.pushNotifications} onCheckedChange={() => updateNotification('pushNotifications')} />
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <MessageSquare className="w-5 h-5 text-purple-500" />
                <span className="font-medium text-gray-900 dark:text-white">{t('settings.smsNotifications')}</span>
              </div>
              <Switch checked={notifications.smsNotifications} onCheckedChange={() => updateNotification('smsNotifications')} />
            </div>
          </div>
        </div>

        {/* Dark Mode */}
        <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">{t('settings.appearance')}</h3>

          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              {theme === 'dark' ? <Moon className="w-5 h-5 text-blue-500" /> : <Sun className="w-5 h-5 text-orange-500" />}
              <span className="font-medium text-gray-900 dark:text-white">{t('settings.darkMode')}</span>
            </div>
            <Switch checked={theme === 'dark'} onCheckedChange={toggleTheme} />
          </div>
        </div>

        {/* Energy Saving Tips - Only show when enabled */}
        {shouldShowTips && <div className="bg-gradient-to-r from-green-50 to-blue-50 dark:from-green-900 dark:to-blue-900 rounded-xl p-4 border border-green-200 dark:border-green-700">
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 flex items-center space-x-2">
              <span>💡</span>
              <span>{t('settings.energySavingTips')}</span>
            </h4>
            <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-1">
              <li>• {t('settings.tipTurnOff')}</li>
              <li>• {t('settings.tipScheduling')}</li>
              <li>• {t('settings.tipStandby')}</li>
              <li>• {t('settings.tipLed')}</li>
            </ul>
          </div>}
      </div>
    </MainLayout>;
};
export default Notifications;